import { render, staticRenderFns } from "./staffStyle.vue?vue&type=template&id=6c452f74&scoped=true&"
import script from "./staffStyle.vue?vue&type=script&lang=js&"
export * from "./staffStyle.vue?vue&type=script&lang=js&"
import style0 from "./staffStyle.vue?vue&type=style&index=0&id=6c452f74&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c452f74",
  null
  
)

export default component.exports